
import { defaultNs } from 'lib/i18n/defaults'
import { getAllContentItems, getContentBySlug } from 'lib/utils/mdx-content';
import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { serialize } from 'next-mdx-remote/serialize'
import { MDXRemote } from 'next-mdx-remote'
import Footer from 'components/footer/Footer';
import MdxLayout from 'components/layout/MdxLayout';

interface Props {
    source: any;
}

const DocsPage: NextPage<Props> = ({ source }) => {
    return (
        <>
            <MdxLayout>
                <MDXRemote {...source} />
            </MdxLayout>
            <Footer questions={false} />
        </>
    )
}

export default DocsPage;

export const getStaticProps = async ({ params, locale }) => {

    const item = await getContentBySlug(params.slug, ['content'], locale)
    const mdxSource = await serialize(item.content)

    return {
        props: {
            source: mdxSource,
            ...await serverSideTranslations(locale, [...defaultNs]),
        }
    }

};

export async function getStaticPaths({ locales }: { locales: string[] }) {

    const items = await getAllContentItems(['slug'])
    // const localizedItems = await Promise.all(locales.map(async locale => {
    //     return {
    //         locale,
    //         items: await getAllContentItems(['slug'])
    //     }
    // }))

    return {
        paths: items.map(item => {
            return {
                params: {
                    slug: item.slug,
                },
                locale: item.locale
            }
        }),

        // paths: items.map((item) => {
        //     return locales.map(locale => {
        //         return {
        //             params: {
        //                 slug: item.slug,
        //             },
        //             locale
        //         }
        //     })
        // }).flat(),
        fallback: false,
    }
}